import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
//import { UsersComponent } from './users/users.component';
//import { RolesComponent } from './roles/roles.component';
//import { BusinessComponent } from './business/business.component';
import { AuthGuardService } from './globalService/auth-guard.service';
//import { ConfigurationPageComponent } from './navegacion/configuration-page/configuration-page.component';
//import { CiudadesComponent } from './parametricas/ciudades/ciudades.component';
//import { ParametricasComponent } from './parametricas/parametricas.component';
//import { ProgramComponent } from './program/program.component';
//import { AseguradorasComponent } from './parametricas/aseguradoras/aseguradoras.component';
//import { RamoComponent } from './parametricas/ramo/ramo.component';
//import { RegionalComponent } from './parametricas/regional/regional.component';
//import { CentroCostosComponent } from './parametricas/centro-costos/centro-costos.component';
//import { UenComponent } from './parametricas/uen/uen.component';
//import { AmparosComponent } from './parametricas/amparos/amparos.component';
//import { CategoriasComponent } from './parametricas/categorias/categorias.component';
//import { EstadosComponent } from './parametricas/estados/estados.component';
//import { DocumentosSiniestrosComponent } from './parametricas/documentos-siniestros/documentos-siniestros.component';
//import { ContactoAseguradorasComponent } from './parametricas/contacto-aseguradoras/contacto-aseguradoras.component';
//import { ClainsComponent } from './clains/clains.component';
//import { RadicacionSiniestroComponent } from './clains/radicacion-siniestro/radicacion-siniestro.component';
//import { ReportesSiniestroComponent } from './clains/reportes-siniestro/reportes-siniestro.component';
//import { SiniestrosPoComponent } from './clains/siniestros-po/siniestros-po.component';
//import { SarlaftComponent } from './sarlaft/sarlaft.component';
//import { SolicitudPolizaComponent } from './we-pac/solicitud-poliza/solicitud-poliza.component';
//import { WorkflowComponent } from './we-pac/workflow/workflow.component';
//import { WePACComponent } from './we-pac/we-pac.component';
//import { AdministracionComponent } from './navegacion/administracion/administracion.component';
//import { MasivoComponent } from './contratistas/masivo/masivo.component';
//import { WorkflowEstadosComponent } from './we-pac/workflow-estados/workflow-estados.component';
//import { ContractComponent } from './we-pac/contract/contract.component';
//import { CumpComponent } from './we-pac/slips/cump/cump.component';
//import { RceComponent } from './we-pac/slips/rce/rce.component';
//import { SoComponent } from './we-pac/slips/so/so.component';
//import { AutorizacionesComponent } from './we-pac/autorizaciones/autorizaciones.component';
//import { IndividualComponent } from './contratistas/individual/individual.component';
//import { ModificacionComponent } from './we-pac/solicitud-poliza/modificacion/modificacion.component';
//import { ModifyContractComponent } from './we-pac/contract/modify-contract/modify-contract.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout/auth-layout.component';
//import { ModifyCumpComponent } from './we-pac/slips/modify/modify-cump/modify-cump.component';
//import { CreacionPolizaGlobalComponent } from './pages/polizas-globales/creacion-poliza-global/creacion-poliza-global.component';
//import { ModifiRceComponent } from './we-pac/slips/modify/modifi-rce/modifi-rce.component';
//import { ModifySoComponent } from './we-pac/slips/modify/modify-so/modify-so.component';
//import { ReportesPacsComponent } from './we-pac/reportes-pacs/reportes-pacs.component'
//import { BillingComponent } from './we-pac/billing/billing/billing.component';
//import { CollectionComponent } from './we-pac/billing/collection/collection.component';
//import { SolicitudInclusionComponent } from './pages/polizas-globales/solicitud-inclusion/solicitud-inclusion.component';
//import { PgWorkflowComponent } from './pages/polizas-globales/workflow/pg-workflow/pg-workflow.component';
//import { GestionSolicitudesComponent } from './we-pac/navegacion/gestion-solicitudes/gestion-solicitudes.component';
//import { PgContractorIndividualComponent } from './pages/polizas-globales/contractor/pg-contractor-individual/pg-contractor-individual.component';
//import { WorkflowAvisoPosibleIncumplimientoComponent } from './pages/aviso-posible-incumplimiento/workflow-aviso-posible-incumplimiento/workflow-aviso-posible-incumplimiento.component';
//import { ApiTicketComponent } from './pages/aviso-posible-incumplimiento/api-ticket/api-ticket.component';
//import { RegistroSeguimientoComponent } from './pages/aviso-posible-incumplimiento/registro-seguimiento/registro-seguimiento.component';
//import { ApiWorkflowStateComponent } from './pages/aviso-posible-incumplimiento/api-workflow-state/api-workflow-state.component';
//import { ReportFilterComponent } from './we-pac/reportes-pacs/report-filter/report-filter.component';
// import { CreatePolicyComponent } from './pages/polizas-fuera-programa/create-policy/create-policy.component';
// import { PfpCumpComponent } from './pages/polizas-fuera-programa/bouquet/pfp-cump/pfp-cump.component';
// import { PfpRceComponent } from './pages/polizas-fuera-programa/bouquet/pfp-rce/pfp-rce.component';
// import { PfpSoComponent } from './pages/polizas-fuera-programa/bouquet/pfp-so/pfp-so.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
// import { WorkflowPfpComponent } from './pages/polizas-fuera-programa/workflowpfp/workflowpfp.component';
import { ClainsLayoutComponent } from './layouts/clains-layout/clains-layout.component';
import { WepacLayoutComponent } from './layouts/wepac-layout/wepac-layout.component';
import { SarlaftLayoutComponent } from './layouts/sarlaft-layout/sarlaft-layout.component';
import { UserComercialComponent } from './pages/user-comercial/user-comercial.component';
import { CuposycumulosLayoutComponent } from './layouts/cuposycumulos-layout/cuposycumulos-layout.component';
import { WeCumplimientoLayoutComponent } from './layouts/wecumplimiento-layout/wecumplimiento-layout.component';


const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AuthGuardService], data: { modulo: -100 } },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/auth/auth-layout/auth-layout.module').then(m => m.AuthLayoutModule)
        /*loadChildren: './layouts/auth/auth-layout/auth-layout.module#AuthLayoutModule'*/
      }
    ]
  },
  {
    path:'admin',
    component: AdminLayoutComponent,
    children:[
      {
        path: '',
        loadChildren: () => import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule)
        /*loadChildren: './layouts/admin-layout/admin-layout.module#AdminLayoutModule'*/
      }
    ]
  },{
    path:'clains',
    component: ClainsLayoutComponent,
    children:[
      {
        path: '',
        loadChildren: () => import('./layouts/clains-layout/clains-layout.module').then(m => m.ClainsLayoutModule)
        /*loadChildren:'./layouts/clains-layout/clains-layout.module#ClainsLayoutModule'*/
      }
    ]
  },{
    path:'wepac',
    component: WepacLayoutComponent,
    children:[
      {
        path: '',
        loadChildren: () => import('./layouts/wepac-layout/wepac-layout.module').then(m => m.WepacLayoutModule)
        /*loadChildren:'./layouts/wepac-layout/wepac-layout.module#WepacLayoutModule'*/
      }
    ]
  },
  {
    path:'sarlaft',
    component: SarlaftLayoutComponent,
    children:[
      {
        path: '',
        loadChildren: () => import('./layouts/sarlaft-layout/sarlaft-layout.module').then(m => m.SarlaftLayoutModule)
        /*loadChildren:'./layouts/sarlaft-layout/sarlaft-layout.module#SarlaftLayoutModule'*/
      }
    ]
  },
  {
    path:'cuposycumulos',
    component: CuposycumulosLayoutComponent,
    children:[
      {
        path: '',
        loadChildren: () => import('./layouts/cuposycumulos-layout/cuposycumulos-layout.module').then(m => m.CuposycumulosLayoutModule)
      }
    ]
  },
  {path:'user-comercial',component:UserComercialComponent},
  {
    path:'weCumplimiento',
    component: WeCumplimientoLayoutComponent,
    children:[
      {
        path: '',
        loadChildren: () => import('./layouts/wecumplimiento-layout/wecumplimiento-layout.module').then(m => m.WeCumplimientoLayoutModule)
      }
    ]
  },
  //{ path: 'users',component: UsersComponent, canActivate: [AuthGuardService], data: { modulo: 64 } },
  //{ path: 'roles', component: RolesComponent, canActivate: [AuthGuardService], data: { modulo: 68 } },
  //{ path: 'business', component: BusinessComponent, canActivate: [AuthGuardService], data: { modulo: 67 } },
  //{ path: 'program', component: ProgramComponent, canActivate: [AuthGuardService], data: { modulo: 13 } },
  //{ path: 'config', component: ConfigurationPageComponent, canActivate: [AuthGuardService], data: { modulo: 6 } },
  //{ path: 'city', component: CiudadesComponent, canActivate: [AuthGuardService], data: { modulo: 70 } },
  //{ path: 'parameters', component: ParametricasComponent, canActivate: [AuthGuardService], data: { modulo: 65 } },
  //{ path: 'aseguradora', component: AseguradorasComponent, canActivate: [AuthGuardService], data: { modulo: 71 } },
  //{ path: 'ramo', component: RamoComponent, canActivate: [AuthGuardService], data: { modulo: 72 } },
  //{ path: 'regional', component: RegionalComponent, canActivate: [AuthGuardService], data: { modulo: 73 } },
  //{ path: 'uen', component: UenComponent, canActivate: [AuthGuardService], data: { modulo: 75 } },
  //{ path: 'centroCosto', component: CentroCostosComponent, canActivate: [AuthGuardService], data: { modulo: 74 } },
  //{ path: 'amparos', component: AmparosComponent, canActivate: [AuthGuardService], data: { modulo: 77 } },
  //{ path: 'categoria', component: CategoriasComponent, canActivate: [AuthGuardService], data: { modulo: 65 } },
  //{ path: 'estado', component: EstadosComponent, canActivate: [AuthGuardService], data: { modulo: 78 } },
  //{ path: 'documento-siniestro', component: DocumentosSiniestrosComponent, canActivate: [AuthGuardService], data: { modulo: 79 } },
  //{ path: 'contacto-aseguradora', component: ContactoAseguradorasComponent, canActivate: [AuthGuardService], data: { modulo: 80 } },
  //{ path: 'clains', component: ClainsComponent, canActivate: [AuthGuardService], data: { modulo: 43 } },
  //{ path: 'radicacion-siniestro', component: RadicacionSiniestroComponent, canActivate: [AuthGuardService], data: { modulo: 44 } },
  //{ path: 'reportes-siniestro', component: ReportesSiniestroComponent, canActivate: [AuthGuardService], data: { modulo: 46 } },
  //{ path: 'siniestro-po', component: SiniestrosPoComponent, canActivate: [AuthGuardService], data: { modulo: 87 } },
  //{ path: 'sarlaft', component: SarlaftComponent, canActivate: [AuthGuardService], data: { modulo: 52 } },
  //{ path: 'solicitud-poliza', component: SolicitudPolizaComponent, canActivate: [AuthGuardService], data: { modulo: 21 } },
  //{ path: 'workflow', component: WorkflowComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  //{ path: 'wepac', component: WePACComponent, canActivate: [AuthGuardService], data: { modulo: 12 } },
  //{ path: 'gestion-solicitudes', component: GestionSolicitudesComponent, canActivate: [AuthGuardService], data: { modulo: 111 } },
  //{ path: 'administracion', component: AdministracionComponent, canActivate: [AuthGuardService], data: { modulo: 3 } },
  //{ path: 'contratistaMasivo', component: MasivoComponent, canActivate: [AuthGuardService], data: { modulo: 63 } },
  //{ path: 'workflow-estados/:idTicket/:estadoTicket', component: WorkflowEstadosComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  //{ path: 'contract/:idProgramV/:idTicket/:nameProgram/:isEditSlip', component: ContractComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  //{ path: 'cumplimiento/:idContract', component: CumpComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  //{ path: 'cumplimiento/:idConditionPolicy/:flag', component: CumpComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  //{ path: 'cumplimiento/:conditionPolicy/:flag/:isEditSlip', component: CumpComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  //{ path: 'rce/:idContract', component: RceComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  //{ path: 'rce/:idConditionPolicy/:flag', component: RceComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  //{ path: 'rce/:conditionPolicy/:flag/:isEditSlip', component: RceComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  //{ path: 'seriedadOferta/:idContract', component: SoComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  //{ path: 'seriedadOferta/:idConditionPolicy/:flag', component: SoComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  //{ path: 'seriedadOferta/:conditionPolicy/:flag/:isEditSlip', component: SoComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  //{ path: 'autorizaciones', component: AutorizacionesComponent, canActivate: [AuthGuardService], data: { modulo: 18 } },
  //{ path: 'contratistaIndividual', component: IndividualComponent, canActivate: [AuthGuardService], data: { modulo: 17 } },
  // { path: 'modificacionPoliza', component: ModificacionComponent, canActivate: [AuthGuardService], data: { modulo: 33 } },
  //{ path: 'modifyContract', component: ModifyContractComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  //{ path: 'poliza-global-create', component: CreacionPolizaGlobalComponent },
  //{ path: 'solicitud-inclusion', component: SolicitudInclusionComponent },
  //{ path: 'workflow-posible-incumplimiento', component: WorkflowAvisoPosibleIncumplimientoComponent, data: { modulo: 48 } },
  //{ path: 'registro-seguimiento/:idTicket/:estadoTicket/:ticket', component: RegistroSeguimientoComponent, data: { modulo: 48 } },
  //{ path: 'reportes-pacs', component: ReportesPacsComponent, canActivate: [AuthGuardService], data: { modulo: 62 } },
  //{ path: 'report-filter/:reportId', component: ReportFilterComponent, canActivate: [AuthGuardService], data: { modulo: 62 } },
  
  //{ path: 'modifyContract/:idTicket', component: ModifyContractComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  // { path: 'modifyCump/:data', component: ModifyCumpComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  // { path: 'modifyCump/:idConditionPolicy/:flag', component: ModifyCumpComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  // { path: 'modifyRce/:data', component: ModifiRceComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  // { path: 'modifyRce/:idConditionPolicy/:flag', component: ModifiRceComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  // { path: 'modifySo/:data', component: ModifySoComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  // { path: 'modifySo/:idConditionPolicy/:flag', component: ModifySoComponent, canActivate: [AuthGuardService], data: { modulo: 11 } },
  // { path: 'billing', component: BillingComponent, canActivate: [AuthGuardService], data: { modulo: 60 } },
  // { path: 'collection', component: CollectionComponent, canActivate: [AuthGuardService], data: { modulo: 61 } },
  //{ path: 'pgWorkflow', component: PgWorkflowComponent, canActivate: [AuthGuardService] },
  //{ path: 'pgContractorI', component: PgContractorIndividualComponent, canActivate: [AuthGuardService] },
  //{ path: 'posibleIncumplimiento', component: ApiTicketComponent, canActivate: [AuthGuardService], data: { modulo: 48 } },
  //{ path: 'apiSummary/:idApiTicket', component: ApiWorkflowStateComponent, canActivate: [AuthGuardService], data: { modulo: 48 } },
  
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }

